import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "column field" };
const _hoisted_2 = { style: { "display": "flex" } };
const _hoisted_3 = {
    key: 0,
    class: "label"
};
const _hoisted_4 = { class: "control" };
const _hoisted_5 = ["value", "disabled", "placeholder"];
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormNumberField',
    props: {
        modelValue: {},
        label: {},
        validator: { type: Function },
        validationId: {},
        placeholder: {},
        isDisabled: { type: Boolean },
        isPassword: { type: Boolean }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // The input element where the form field's value will be bound
        const inputElem = ref(null);
        // Event for two-way binding
        const emit = __emit;
        const onInput = () => {
            emit('update:modelValue', parseFloat(inputElem.value.value));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.label)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.label), 1))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "top")
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("input", {
                        ref_key: "inputElem",
                        ref: inputElem,
                        class: _normalizeClass(["input", { 'is-danger': _ctx.validator ? !_ctx.validator(_ctx.validationId ? _ctx.validationId : this, _ctx.modelValue) : false }]),
                        type: "number",
                        value: _ctx.modelValue,
                        onInput: _cache[0] || (_cache[0] = ($event) => (onInput())),
                        disabled: _ctx.isDisabled,
                        placeholder: _ctx.placeholder
                    }, null, 42, _hoisted_5),
                    _renderSlot(_ctx.$slots, "default")
                ])
            ]));
        };
    }
});
